<div class="dialog">
  <h1 mat-dialog-title class="dialog-title">
    {{ data.title }}
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <div mat-dialog-content class="dialog-content text">
    {{ data.text }}
    <div *ngIf="data.warningText" class="dialog-warning red">
      {{ data.warningText }}
    </div>
    <mat-form-field
      *ngIf="requiresReason"
      appearance="outline"
      class="w-100-p mt-16"
    >
      <mat-label>{{ data.reasonLabel }}</mat-label>
      <textarea
        matInput
        required
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        [(ngModel)]="reason"
        data-testid="confirm-dialog-reason-input"
      ></textarea>
      <mat-error>A reason is required.</mat-error>
    </mat-form-field>
  </div>

  <div mat-dialog-actions>
    <button
      *ngIf="!requiresReason"
      mat-button
      [class]="confirmBtnClass"
      [mat-dialog-close]="!data.reverseBtn"
    >{{ confirmBtnText }}</button>
    <button
      *ngIf="requiresReason"
      mat-button
      [class]="confirmBtnClass"
      [disabled]="!isReasonValid"
      (click)="confirmWithReason()"
      data-testid="confirm-dialog-confirm-btn"
    >{{ confirmBtnText }}</button>
    <button
      mat-button
      [class]="cancelBtnClass"
      [mat-dialog-close]="requiresReason ? false : data.reverseBtn"
    >{{ cancelBtnText }}</button>
  </div>
</div>
